import React from 'react'

const SiteNavigationToggle =({isActive, onToggle}) => {
    const classActive = isActive ? ' is-active' : ''

    return (
        <button className={"site-navigation-toggle hamburger hamburger--elastic" + classActive} aria-controls="Top menü" aria-expanded="false" onClick={onToggle}>
            <span className="hamburger-box">
                <span className="hamburger-inner">
                    <span className="screen-reader-text">Menü</span>
                </span>
            </span>
        </button>
    )
}

export default SiteNavigationToggle